<div class="detail-container">
  <nb-card>
    <nb-card-header>
      <button nbButton ghost status="primary" (click)="navigateBack()">
        <nb-icon pack="eva" icon="arrow-back-outline"></nb-icon>
      </button>
      <h5>TGA Bauplan</h5>
      @if (canEdit() && !isNew()) {
        <wr-edit-delete-button-group (edit)="onEdit()" (delete)="onDelete()">
        </wr-edit-delete-button-group>
      }
    </nb-card-header>
    <nb-card-body>
      <nb-tabset class="vertical-tabset" (changeTab)="onTabChange($event)">
        <nb-tab tabTitle="Stammdaten">
          <wr-tga-type-form></wr-tga-type-form>
        </nb-tab>
        @if (!isNew()) {
          <nb-tab tabTitle="Feldgruppen">
            <wr-tga-type-collections></wr-tga-type-collections>
          </nb-tab>
        }
        @if (!isNew()) {
          <nb-tab tabTitle="Protokolltypen">
            <wr-tga-type-protocol-types></wr-tga-type-protocol-types>
          </nb-tab>
        }
        @if (!isNew()) {
          <nb-tab tabTitle="Wartungstimer">
            <wr-tga-type-maintenance-timer-configs></wr-tga-type-maintenance-timer-configs>
          </nb-tab>
        }
        @if (isNew() ? null : id(); as tgaTypeId) {
          <nb-tab tabTitle="Verknüpfungen">
            <wr-tga-type-linked-checkpoints [equipmentId]="tgaTypeId"
                                            [isEditing]="isEditing()"></wr-tga-type-linked-checkpoints>
          </nb-tab>
        }
      </nb-tabset>
    </nb-card-body>
    @if (canEdit()) {
      <nb-card-footer>
        <button size="medium" [disabled]="!isEditing()" nbButton status="primary" (click)="submit()">Speichern</button>
        <button size="medium" [disabled]="!isEditing()" nbButton status="basic" (click)="cancel()">Abbrechen</button>
      </nb-card-footer>
    }
  </nb-card>
</div>
